module.exports = {
  xxxs: '320px',
  xxs: '375px',
  xs: '500px',
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  xxl: '1500px'
}



//////////////////
// WEBPACK FOOTER
// ./tailwind.screens.js
// module id = ./tailwind.screens.js
// module chunks = main